angular.module('picmonicng').directive('monthSelect', [
  'MonthOptionsConfig',
  function (MonthOptionsConfig) {
    return {
      restrict: 'E',
      scope: {
        monthId: '=',
        isRequired: '=',
      },
      link: function (scope, element, attrs) {
        scope.months = MonthOptionsConfig.months;

        if (!isNaN(scope.isRequired) && scope.isRequired > 0) {
          scope.isRequired = true;
        } else if (scope.isRequired == '') {
          scope.isRequired = false;
        }
      },
      template:
        '<select class="form-control" ng-model="monthId" ng-options="month.id as month.name for month in months | orderBy: \'id\'" ng-required="isRequired"><option value="">Select</option></select>',
    };
  },
]);
